import { useGetAddressType } from "@common/hook/useGetAddressType";
import { EADDRESS_TYPES } from "@constants";
import { ReplacementSimAddressForm } from "./ReplacementSimAddressForm";
import { useGetUserContact } from "../Profile/UserDetails/hooks/useGetUserContact";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    closeForm(): void;
    onSuccessCallback(): void;
}

export const ReplacementSimAddress = (props: IParams) => {
    const { closeForm, onSuccessCallback } = props;

    const { getUserAddress, addressField, getUserAddressState } = useGetAddressType(EADDRESS_TYPES.DELIVERY);
    const { userDetails, getUserDetailsState, getUserDetails } = useGetUserContact();

    const error = getUserAddressState.error ?? getUserDetailsState.error;
    const isLoading = getUserAddressState.isLoading ?? getUserDetailsState.isLoading;
    const retryFetch = getUserAddressState.error ? getUserAddress : getUserDetails;

    return (
        <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={retryFetch}>
            {addressField && (
                <ReplacementSimAddressForm
                    closeForm={closeForm}
                    deliveryAddress={addressField}
                    userDetails={userDetails}
                    onSuccessCallback={onSuccessCallback}
                />
            )}
        </HandleErrorAndLoading>
    );
};
